import { createContext, useContext, useMemo } from 'react';
import { baseURL } from 'lib';
import io from 'socket.io-client';

const SocketContext = createContext();

const useSocket = () => useContext(SocketContext);

const SocketProvider = ({ children }) => {
    const socket = useMemo(() => io(baseURL), []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    )
};

export { useSocket, SocketProvider }